/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeSquareIcon20Regular = forwardRef('ShapeSquareIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 6A3.75 3.75 0 0 1 6 2.25h8A3.75 3.75 0 0 1 17.75 6v8A3.75 3.75 0 0 1 14 17.75H6A3.75 3.75 0 0 1 2.25 14V6ZM6 3.75A2.25 2.25 0 0 0 3.75 6v8A2.25 2.25 0 0 0 6 16.25h8A2.25 2.25 0 0 0 16.25 14V6A2.25 2.25 0 0 0 14 3.75H6Z" })));
});
